import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
export function renderPartnersTable({ getSortAttributes }) {
    const columns = getColumns(getSortAttributes);
    return renderKoDataTable({
        title: 'Partners',
        titleIcon: 'users',
        caption: 'Recruiting partners',
        columns,
        className: 'partners-table',
        children: renderBody(columns),
    });
}
function getColumns(getSortAttributes) {
    return [
        { key: 'displayOrder', label: 'Order', sortable: true, sortAttributes: getSortAttributes('displayOrder'), width: 104, minWidth: 88, resizable: true },
        { key: 'id', label: 'ID', sortable: true, sortAttributes: getSortAttributes('id'), width: 88, minWidth: 72, resizable: true },
        { key: 'internalName', label: 'Internal name', sortable: true, sortAttributes: getSortAttributes('internalName'), minWidth: 240, resizable: true },
        { key: 'name', label: 'Name', sortable: true, sortAttributes: getSortAttributes('name'), minWidth: 220, resizable: true },
        { key: 'channel', label: 'Channel', width: 160, minWidth: 128, resizable: true },
        { key: 'status', label: 'Status', width: 128, minWidth: 104, resizable: true },
        { key: 'actions', label: 'Actions', align: 'center', width: 96, minWidth: 88, required: true },
    ];
}
function renderBody(columns) {
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: partners' },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'displayOrder' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: '$data.internalName || $data.internal_name || ""', titleBinding: '$data.internalName || $data.internal_name || ""' })}
                    ${renderRecruitingTextCell({ column: columns[3], binding: '$data.name || $data.title || ""', titleBinding: '$data.name || $data.title || ""' })}
                    ${renderRecruitingTextCell({ column: columns[4], binding: '$data.channelName || $data.channel || ""' })}
                    ${renderRecruitingStatusCell({
                column: columns[5],
                textBinding: '$data.statusLabel || (Number($data.status || $data.partnerStatus || 0) === 1 ? "Active" : "Inactive")',
                cssBinding: `
                            'task-status--success': Number($data.status || $data.partnerStatus || 0) === 1,
                            'task-status--pending': Number($data.status || $data.partnerStatus || 0) !== 1
                        `,
            })}
                    ${LpTable.Cell({ column: columns[6], children: LpButton({ ariaLabel: 'Edit', prefixIcon: 'pencil-simple', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickEdit' } }) })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'partners().length === 0', title: 'No partners found', description: 'No partners match the selected filters.', icon: 'users' })}
    `;
}
